var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-field',{attrs:{"right-icon":"clear","placeholder":_vm.placeholder},on:{"click-right-icon":_vm.clear,"blur":_vm.blur},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }